<template>
  <div>
    <main class="l-content">
      <section class="l-section wpb_row height_small mpc-row basket">
        <div class="l-section-h basket__inner">
          <div class="basket__not-product" v-if="!basket.length">
            <div class="basket__not-product-ico">
              <i class="fa fa-shopping-basket"></i>
            </div>
            <h4 class="basket__not-product-title">{{ $t("Кошик порожній") }}</h4>
            <p class="basket__not-product-text">
              {{ $t("Ви нічого не додали у кошик, перейдіть у розділ доставки") }}
            </p>
            <router-link
              :to="{ name: 'delivery', params: { restaurantId: activeRestaurantId } }"
              class="base-btn"
            >
              {{ $t("Доставка") }}
            </router-link>
          </div>
          <template v-else>
            <h1 class="basket__title">
              {{ $t("Оформлення замовлення") }} <br/>
              {{ $t("y закладі") }}
              {{
                active_restaurant &&
                (active_restaurant.category
                  ? active_restaurant.category.name
                  : active_restaurant.title)
              }}
            </h1>

            <div class="basket__wrap" :class="{ _loading: !loadedSettings }">
              <BasePreloader v-if="!loadedSettings"/>
              <template v-else>
                <div class="basket__form">
                  <FormBasket
                    :inputs="inputs"
                    :restaurantsSelfPickup="restaurantsSelfPickup"
                    @input="setInput"
                    ref="formBasket"
                  />
                  <BaseAlertInline :value="overallErrorsMix" class="basket__error _warning"/>
                </div>
                <div class="basket__content">
                  <div class="basket__product-list product-list">
                    <div class="product-list__header d-sm-none">
                      <div class="product-list__header-col">{{ $t("Товар") }}</div>
                      <div class="product-list__header-col">{{ $t("Загалом") }}</div>
                    </div>
                    <div class="product-list__body">
                      <BasketItem
                        v-for="basketItem in basket"
                        :key="basketItem.specificId"
                        :basketItem="basketItem"
                        class="product-list__item"
                      />
                    </div>
                    <div class="basket__clean">
                      <button type="button" class="base-btn" @click="handleClearBasket">
                        {{ $t("Очистити корзину") }}
                      </button>
                    </div>
                    <div class="product-list__footer">
                      <div class="product-list__footer-content">
                        <div class="product-list__footer-item">
                          <span class="product-list__footer-item-label">{{ $t("Товари") }}:</span>
                          <span class="product-list__footer-item-value"
                          >{{ productsPrice | formatPrice }} {{ $t("грн") }}</span
                          >
                        </div>
                        <div class="product-list__footer-item" v-if="totalPackingPrice">
                          <span class="product-list__footer-item-label"
                          >{{ $t("Пакування") }}:</span
                          >
                          <span class="product-list__footer-item-value"
                          >{{ totalPackingPrice | formatPrice }} {{ $t("грн") }}</span
                          >
                        </div>
                        <div class="product-list__footer-item">
                          <span class="product-list__footer-item-label">{{ $t("Доставка") }}:</span>
                          <span class="product-list__footer-item-value"
                          >{{ deliveryPrice | formatPrice }} {{ $t("грн") }}</span
                          >
                        </div>

                        <transition name="fade">
                          <div class="product-list__footer-item" v-if="discount">
                            <span class="product-list__footer-item-label"
                            >{{ $t("Знижка при самовивозі") }}
                              {{ settings.selfPickingActionDiscount }}%:</span
                            >
                            <span class="product-list__footer-item-value"
                            >-{{ discount | formatPrice }} {{ $t("грн") }}</span
                            >
                          </div>
                        </transition>
                        <div class="product-list__footer-item _total">
                          <span class="product-list__footer-item-label"
                          >{{ $t("Разом до оплати") }}:</span
                          >

                          <div class="product-list__footer-item-value">
                            <svg
                              v-if="isDishWithWeightIncluded"
                              class="product-list__approximately_price"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <use xlink:href="#ico-approximately"></use>
                            </svg>

                            {{ totalPrice | formatPrice }} {{ $t("грн") }}
                          </div>
                        </div>

                        <div class="product-list__weight_warning" v-if="isDishWithWeightIncluded">
                          <svg class="product-list__weight_warning__ico" xmlns="http://www.w3.org/2000/svg">
                            <use xlink:href="#ico-info"></use>
                          </svg>
                          {{ $t("weight warning") }}
                        </div>
                        <h4 class="page-footer__title"></h4>
                      </div>
                    </div>
                  </div>
                  <transition name="fade">
                    <div
                      v-if="!showByDelivery([DELIVERY_METHOD_SELF])"
                      class="basket__details basket-details"
                    >
                      <div class="basket-details__label">{{ $t("Деталі") }}</div>

                      <BaseCheckbox
                        v-model="inputs.do_not_call.value"
                        @input="setInput(['call_me_back', Number($event)])"
                        class="basket-details__checkbox"
                      >
                        <span class="checkbox__text">
                          <BaseSvg class="checkbox__icon" name="ico-call-me-back"/>
                          {{ $t("Зателефонувати мені для підтвердження") }}
                        </span>
                      </BaseCheckbox>

                      <!--                      <BaseCheckbox-->
                      <!--                        v-model="inputs.do_not_call.value"-->
                      <!--                        @input="setInput(['do_not_call', $event])"-->
                      <!--                        class="basket-details__checkbox"-->
                      <!--                      >-->
                      <!--                        <span class="checkbox__text">-->
                      <!--                          <BaseSvg class="checkbox__icon" name="ico-mute"/>-->
                      <!--                          {{ $t("Не дзвонити в двері") }}-->
                      <!--                        </span>-->
                      <!--                      </BaseCheckbox>-->

                      <!--                      <BaseCheckbox-->
                      <!--                        v-model="inputs.have_a_child.value"-->
                      <!--                        @input="setInput(['have_a_child', $event])"-->
                      <!--                        class="basket-details__checkbox"-->
                      <!--                      >-->
                      <!--                        <span class="checkbox__text">-->
                      <!--                          <BaseSvg class="checkbox__icon" name="ico-stroller"/>-->
                      <!--                          {{ $t("У мене мала дитина (до 12 років)") }}-->
                      <!--                        </span>-->
                      <!--                      </BaseCheckbox>-->

                      <!--                      <BaseCheckbox-->
                      <!--                        v-model="inputs.have_a_dog.value"-->
                      <!--                        @input="setInput(['have_a_dog', $event])"-->
                      <!--                        class="basket-details__checkbox"-->
                      <!--                      >-->
                      <!--                        <span class="checkbox__text">-->
                      <!--                          <BaseSvg class="checkbox__icon" name="ico-animal-kingdom"/>-->
                      <!--                          {{ $t("У мене є собака") }}-->
                      <!--                        </span>-->
                      <!--                      </BaseCheckbox>-->
                    </div>
                  </transition>
                </div>
              </template>
            </div>
            <div class="basket__form-btn">
              <button type="button" class="base-btn _black" @click="sendForm">
                {{ $t("Оформити замовлення") }}
                <BasePreloader v-if="pending"/>
              </button>
            </div>
          </template>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import {http} from "@/axios";
import {mapActions, mapState} from "vuex";
import BasketItem from "@/components/BasketItem";
import getBasketItemPackingPrice from "@/helpers/getBasketItemPackingPrice";
import getBasketItemPrice from "@/helpers/getBasketItemPrice";
import FormBasket from "@/components/FormBasket";
import formMixins from "@/mixins/formMixins";
import {DELIVERY_METHOD_ADDRESS, DELIVERY_METHOD_SELF} from "@/constants/deliveryMethods";
import formatPrice from "@/helpers/formatPrice";

const addressRequired = ["name", "phone", "city_id", "street", "house_number", "time"];
const selfRequired = ["name", "phone", "time_self", "restaurant"];

export default {
  name: "Basket",
  mixins: [formMixins],
  components: {FormBasket, BasketItem},
  data() {
    return {
      pending: false,
      inputs: {
        name: {
          value: null,
        },
        phone: {
          value: null,
        },
        city_id: {
          value: null,
        },
        street: {
          value: null,
        },
        entrance: {
          value: null,
        },
        house_number: {
          value: null,
        },
        apartment_number: {
          value: null,
        },
        time: {
          value: null,
        },
        time_self: {
          value: null,
        },
        comment: {
          value: null,
        },
        delivery_type: {
          value: null,
        },
        payment_type: {
          value: null,
        },
        do_not_call: {
          value: null,
        },
        have_a_child: {
          value: null,
        },
        have_a_dog: {
          value: null,
        },
        call_me_back: {
          value: null,
        },
        use_bonuses: {
          value: false,
        },
        restaurant: {
          value: null,
        },
        from_site: {
          value: true,
        }
      },
      DELIVERY_METHOD_ADDRESS,
      DELIVERY_METHOD_SELF,
    };
  },
  computed: {
    ...mapState("basket", ["basket"]),
    ...mapState("restaurants", ["all_restaurants"]),
    ...mapState("restaurants", ["active_restaurant"]),
    ...mapState("settings", ["settings"]),
    ...mapState("user", ["profile"]),
    ...mapState({
      loadedSettings(state) {
        return (state.settings && state.settings.loaded) || false;
      },
    }),
    free_delivery_sum() {
      return this.inputs.city_id.value && this.inputs.city_id.value.free_minimum_order || undefined
    },
    discount() {
      if (
        this.showByDelivery([DELIVERY_METHOD_SELF]) &&
        this.settings &&
        this.settings.isSelfPickingActionAvailable &&
        this.settings.selfPickingActionDiscount > 0
      ) {
        return (
          (this.fullProductsPrice + this.deliveryPrice) *
          (parseFloat(this.settings.selfPickingActionDiscount) / 100)
        );
      }
      return 0;
    },
    activeRestaurantId() {
      let id = window.localStorage.getItem("active_restaurant_id") || null;
      if (this.active_restaurant) {
        id = this.active_restaurant.id;
      }
      return id;
    },
    isDishWithWeightIncluded() {
      return this.basket.some((item) => item.product.weight_dish);
    },
    totalPackingPrice() {
      let totalPrice = 0;
      this.basket.forEach((item) => {
        totalPrice += getBasketItemPackingPrice(item) * item.quantity;
      });
      return totalPrice;
    },
    productsPrice() {
      let totalPrice = 0;
      this.basket.forEach((item) => {
        totalPrice += getBasketItemPrice(item) * item.quantity;
      });
      return totalPrice;
    },
    fullProductsPrice() {
      return this.productsPrice + this.totalPackingPrice;
    },
    deliveryPrice() {

      if (this.free_delivery_sum) {
        if (this.fullProductsPrice > this.free_delivery_sum) {
          return 0
        }
      }

      if (!this.showByDelivery([DELIVERY_METHOD_ADDRESS])) return 0;

      const city_id = this.inputs.city_id.value || null;
      if (!city_id) return (this.settings && Number(this.settings.deliveryPrice)) || 0;

      if (this.settings && this.settings.homeCityId == city_id.id) {
        if (this.productsPrice >= Number(this.settings.delivery.minKovelFreeDeliveryPrice)) {
          return 0;
        } else {
          return Number(city_id.delivery_price);
        }
      }

      return Number(city_id.delivery_price);
    },
    totalPrice() {

      let sum = this.fullProductsPrice + this.deliveryPrice - this.discount;

      //if (this.inputs.use_bonuses.value) {
      //  sum -= this.bonuses
      //}

      return sum < 0 ? 0 : sum;
    },
    restaurantsSelfPickup() {
      let list = [];

      if (this.active_restaurant) {
        let categoryId =
          (this.active_restaurant &&
            this.active_restaurant.category &&
            this.active_restaurant.category.id) ||
          null;
        if (categoryId) {
          list = this.all_restaurants.filter(
            (item) => parseInt(item.self_picking) && item.category && item.category.id == categoryId
          );
        } else {
          list.push(this.active_restaurant);
          this.setInput(["restaurant", list[0]]);
        }
      }

      if (!this.inputs.restaurant.value) {
        this.setInput(["restaurant", list[0]]);
      }

      return list;
    },
    minOrderPrice() {
      return (this.inputs.city_id.value && Number(this.inputs.city_id.value.minimum_order)) || 0;
    },
  },
  methods: {
    ...mapActions("basket", ["clearBasket"]),

    showByDelivery(types) {
      const id = this.inputs.delivery_type.value && this.inputs.delivery_type.value.id;
      return id && types.includes(id);
    },
    handleClearBasket() {
      this.$vModal.open("message", {
        title: this.$t("Очистити корзину"),
        message: this.$t("Ви дійсно бажаєте очистити корзину?"),
        buttonText: this.$t("Так"),
        callBack: () => {
          this.clearBasket();
        },
      });
    },
    clear() {
      return this.clearBasket();
    },
    setInput([key, value]) {
      if (key === 'city_id') {
        console.log(value)
      }
      this.inputs[key].value = value;
    },
    collectData() {
      const sendData = this.createSendDataMix(this.inputs);
      if (!sendData) return null;

      if (this.showByDelivery([DELIVERY_METHOD_SELF])) {
        sendData.city_id = null;
        sendData.street = null;
        sendData.house = null;
        sendData.entrance = null;
        sendData.apartment_number = null;
        sendData.do_not_call = null;
        sendData.have_a_child = null;
        sendData.have_a_dog = null;
        sendData.time = sendData.time_self;
        delete sendData.time_self;
      } else if (this.showByDelivery([DELIVERY_METHOD_ADDRESS])) {
        // sendData.restaurant = null
        delete sendData.time_self;
      }

      // crutches for crutched backend
      if (sendData.do_not_call) {
        sendData.do_not_call = 1;
      }
      if (sendData.have_a_child) {
        sendData.have_a_child = 1;
      }
      if (sendData.have_a_dog) {
        sendData.have_a_dog = 1;
      }
      //-------------

      if (sendData.time) {
        sendData.time = sendData.time.getTime() / 1000;
      }

      if (sendData.phone) {
        sendData.phone = `380${sendData.phone}`;
      }

      sendData.cart = this.basket.map((item) => {
        const main_ingredients = [];
        const additional_ingredients = [];

        for (const key in item.main_ingredients) {
          const el = item.main_ingredients[key];

          main_ingredients.push({
            ingredient_id: el.ingredient.id,
            quantity: el.quantity,
          });
        }

        for (const key in item.additional_ingredients) {
          const el = item.additional_ingredients[key];

          additional_ingredients.push({
            ingredient_id: el.ingredient.id,
            quantity: el.quantity,
          });
        }

        const result = {
          type: item.type,
          size: item.variant.size,
          comment: item.comment,
          quantity: item.quantity,
          property_id: item.property ? item.property.id : null,
          product_id: item.product.id,
        };

        // crutches for crutched backend
        if (item.type === "classic") {
          result.additional_ingredients =
            (additional_ingredients.length && additional_ingredients) || null;
          result.main_ingredients = (main_ingredients.length && main_ingredients) || null;
        } else {
          result.additional_ingredients = (main_ingredients.length && main_ingredients) || null;
          result.main_ingredients =
            (additional_ingredients.length && additional_ingredients) || null;
        }
        //-------------

        return result;
      });

      return sendData;
    },
    sendForm() {
      this.resetErrorsMix();
      if (
        this.showByDelivery([DELIVERY_METHOD_ADDRESS]) &&
        this.minOrderPrice > this.fullProductsPrice
      ) {
        this.$vModal.open("message", {
          title: this.$t("Увага!"),
          message: `${this.$t(
            "Мінімальна сума замовлення для Вашого населеного пункту становить"
          )} ${this.minOrderPrice | formatPrice()} ${this.$t("грн")}`,
        });
        return;
      }
      const data = this.collectData();

      // console.log('sent form', data)
      if (!data) return;

      this.pending = true;

      http
        .post("/api/order/create", data)
        .then((data) => {
          if (data.data.payment_url) {
            this.$router.push({
              name: "delivery",
              params: {restaurantId: this.activeRestaurantId},
            });
            window.location.href = data.data.payment_url;
            this.clearBasket();
            return;
          }
          this.clearBasket();
          this.$router.push({
            name: "delivery",
            params: {restaurantId: this.activeRestaurantId},
          });
          this.$vModal.open("message", {
            title: this.$t("Оформлення замовлення"),
            message: data.data.message,
          });
        })
        .catch((error) => {
          this.handlerErrorMix(error, this.inputs);
        })
        .finally(() => {
          this.pending = false;
        });
    },
    setRequiredFields() {
      // console.log(this.profile, 'DATTAT')
      const variants =
        this.inputs.delivery_type.value && this.showByDelivery([DELIVERY_METHOD_ADDRESS])
          ? addressRequired
          : selfRequired;

      for (const key in this.inputs) {
        if (variants.includes(key)) {
          this.$set(this.inputs[key], "required", true);
        } else {
          this.$set(this.inputs[key], "required", false);
        }
      }
    },
  },
  watch: {
    "inputs.delivery_type.value"() {
      this.resetErrorsMix();
      this.setRequiredFields();
    },
    profile: {
      handler(to) {
        if (to) {
          console.log(to, "to");
          this.inputs.name.value = to.name;
          this.inputs.phone.value = to.phone.slice(3);
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style></style>
